import { useCallback, useEffect, useState } from "react";
import { workspaceKnowledgeApi } from "@/api/workspaceKnowledgeApi";

/**
 * @param {string | null} logicalId
 */
export function useCollectionDetail(logicalId) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!logicalId) {
      setDetail(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await workspaceKnowledgeApi.getCollection(logicalId);
      setDetail(res?.data ?? null);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Could not load collection.");
      setDetail(null);
    } finally {
      setLoading(false);
    }
  }, [logicalId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { detail, loading, error, refresh };
}
